import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubTodoService } from '../../../../core/services/sub-todo.service';
import { SubTodoForCreation } from '../../../../core/models/subtodos/sub-todo-for-creation.model';

export interface AddSubTodoDialogData {
  todoId: number;
}

@Component({
  selector: 'app-add-subtodo-dialog',
  templateUrl: './add-subtodo-dialog.component.html',
  styleUrls: ['./add-subtodo-dialog.component.css'],
  standalone: false,
})
export class AddSubTodoDialogComponent implements OnInit {
  subtodoForm!: FormGroup;
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private subTodoService: SubTodoService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddSubTodoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddSubTodoDialogData
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.subtodoForm = this.fb.group({
      description: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.subtodoForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;

      const subTodoData: SubTodoForCreation = {
        todoId: this.data.todoId,
        description: this.subtodoForm.value.description
      };

      this.subTodoService.addSubTodo(subTodoData).subscribe({
        next: () => {
          this.snackBar.open('Sub-todo added successfully', 'Close', { duration: 3000 });
          this.dialogRef.close(true);
        },
        error: () => {
          this.snackBar.open('Error adding sub-todo. Please try again.', 'Close', { duration: 3000 });
          this.isSubmitting = false;
        }
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
